import { createContext as reactCreateContext, useContext } from 'react';
const buildDefaultErrorMsg = name => `You tried to access a feature requiring a ${name}Context. Did you forget to wrap your component in a ${name}Provider?`;
/**
 * Creates a named context, provider, and hook.
 *
 * @param options - create context options.
 */
export function createContext(options = {}) {
  const {
    strict = true,
    errorMessage,
    name
  } = options;
  const CustomContext = /*#__PURE__*/reactCreateContext(undefined);
  CustomContext.displayName = name;
  const useCustomContext = () => {
    const context = useContext(CustomContext);
    if (!context && strict) {
      const error = new Error(errorMessage != null ? errorMessage : buildDefaultErrorMsg(name != null ? name : 'Default'));
      error.name = 'ContextError';
      throw error;
    }
    return context;
  };
  return [CustomContext.Provider, useCustomContext, CustomContext];
}
//# sourceMappingURL=index.js.map